import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Referto } from '../models/referto';
import { BackendService } from './backend.service';
import { ConfigService } from './config.service';

const BUILD_TAG:string = "25/11/2020 13:40";

@Injectable({
  providedIn: 'root'
})
export class MainService {

  scope: string;
  sede: string;
  codPaziente: string;
  referti: Referto[];
  inline: boolean = false;

  constructor(private configService: ConfigService,
    private backendService: BackendService
    ) {
    console.log(`BUILD DEL ${BUILD_TAG}`);
  }

  public setLoading(value: boolean) {
    BackendService.setLoading(value);
  }

  public getLoading(): Observable<boolean> {
    return BackendService.getLoading();
  }

  public setReferti(referti: Referto[]) {
    this.referti = referti;
  }

  public getReferti(): Referto[] {
    return this.referti;
  }

  public setScope(scope: string) {
    this.scope = scope;
  }

  public getScope(): string {
    return this.scope;
  }

  public setSede(sede: string) {
    this.sede = sede;
  }

  public getSede(): string {
    return this.sede;
  }

  public setCodPaziente(codPaziente: string) {
    this.codPaziente = codPaziente;
  }

  public getCodPaziente(): string {
    return this.codPaziente;
  }

  public setInline(val: boolean) {
    this.inline = val;
  }

  public isInline(): boolean {
    return this.inline;
  }

  public createReportObject(ref: Referto, container?: HTMLIFrameElement) {
    let url = this.configService
      .getBackendUrl(`/getContentReferto?oper=referto&codSede=${this.getSede()}&uid=${ref.repUid}&scope=${this.getScope()}&codPaziente=${this.getCodPaziente()}&token=${ref.tokenId}`);
    window.open(url, '_blank');
    if (container != null) {
      container.src = url + "&attachment=true";
    }
  }

  public createImmaginiObject(ref: Referto, container?: HTMLDivElement) {
    this.backendService.getUrlImmaginiReferto(this.getScope(), this.getCodPaziente(), this.getSede(), ref).subscribe((url:string) => {
      console.log(`opening url ${url}`);
      window.open(url, '_blank');
    });
  }

  public createReportObjectBdocs(ref:Referto, container: HTMLDivElement) {
    let url = ref.bdocsDocumentUrl;
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = url;
    a.target = 'Cartella clinica digitalizzata - ' + ref.codFiscale;
    a.innerText = 'Premi qui per visualizzare la cartella clinica digitalizzata';
    container.appendChild(a);
    window.open(url, '_blank');
  }



}
